import type { PosCustomerPrefill } from '@/pages/B2B/CRM/customerPrefill';

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

function isNonEmptyString(value: unknown): value is string {
  return typeof value === 'string' && value.trim() !== '';
}

const OPTIONAL_STRING_KEYS = [
  'customer_email',
  'customer_address',
  'customer_city_id',
  'customer_ward_id',
  '_cityName',
  '_wardName',
  'customer_tax_code',
  'invoice_name',
  'invoice_tax_id',
  'invoice_address',
  'invoice_email',
  'delivery_email',
  'delivery_city_id',
  'delivery_ward_id',
  '_deliveryCityName',
  '_deliveryWardName',
  'delivery_address',
] as const;

const ALLOWED_PREFILL_KEYS = new Set([
  'customer_user_id',
  'user_type',
  'customer_name',
  'customer_phone',
  'delivery_same_as_customer',
  'delivery_name',
  'delivery_phone',
  // TCR-2129: kênh B2B của khách — POS cần để bật cột chính sách CK.
  '_b2bChannel',
  ...OPTIONAL_STRING_KEYS,
]);

function isPosCustomerPrefill(
  value: Record<string, unknown>,
): value is PosCustomerPrefill {
  return (
    Object.keys(value).every((key) => ALLOWED_PREFILL_KEYS.has(key)) &&
    isNonEmptyString(value.customer_user_id) &&
    (value.user_type === 'personal' || value.user_type === 'organization') &&
    isNonEmptyString(value.customer_name) &&
    isNonEmptyString(value.customer_phone) &&
    value.delivery_same_as_customer === true &&
    isNonEmptyString(value.delivery_name) &&
    isNonEmptyString(value.delivery_phone) &&
    (value._b2bChannel === undefined || typeof value._b2bChannel === 'string') &&
    OPTIONAL_STRING_KEYS.every(
      (key) => value[key] === undefined || typeof value[key] === 'string',
    )
  );
}

export function readPosCustomerPrefill(
  state: unknown,
): PosCustomerPrefill | undefined {
  if (!isRecord(state) || !isRecord(state.customerPrefill)) return undefined;

  const customerPrefill = state.customerPrefill;
  return isPosCustomerPrefill(customerPrefill) ? customerPrefill : undefined;
}
